import React from 'react';
import { partial } from 'lodash';
import styled from '@emotion/styled';

import colours from '~/utils/colours';
import { isEmail } from '~/utils/String';
import { Profile } from '~/types/models';
import { createProfile } from '~/App/Api/Profile';

const EmailAddress = styled.pre`
  padding: 0.5em;
  cursor: pointer;
  font-weight: bold;
  user-select: none;
  border-radius: 4px;
  margin-bottom: 1em;
  color: ${colours.grey};
  background-color: white;
  border-color: ${colours.greyMedium};
`;

export type AddNewProps = {
  email: string;
  select: (id: string, name: string, profile: Profile) => void;
};

export default function AddNew({ email, select }: AddNewProps) {
  if (!isEmail(email)) {
    return null;
  }

  async function handleEmailAddressClick(email) {
    const profile = await createProfile({ email });

    select(profile.id, profile.name!, profile);
  }

  return (
    <React.Fragment>
      <h5>Add New</h5>
      <EmailAddress
        onClick={partial(handleEmailAddressClick, email)}
        style={{ display: 'inline' }}
      >
        {email}
      </EmailAddress>
    </React.Fragment>
  );
}
